import { getVertical } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const VERTICAL_LIST = "VERTICAL_LIST";

export function useVerticalListQuery() {
	return useQuery({
		queryKey: [VERTICAL_LIST],
		queryFn: processResponse(() => getVertical()),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
